import { useEffect, useRef } from "react";

export const useTimeout = () => {
  //const [alerts, setAlerts] = useState([]);

  const ALERT_DELAY_MILLISECONDS = 1000;

  const alerts = useRef([]);

  useEffect(() => {
    return () => {
      clearTimers();
    };
  }, []);

  useEffect(() => {
    console.log("-CHANGE: " + alerts);
  }, [alerts]);

  const addAlert = (callback, message = "", ms = ALERT_DELAY_MILLISECONDS) => {
    const newAlertObj = {
      id: `success-${Date.now()}`,
      message,
      timerId: undefined,
      callback,
    };

    newAlertObj.timerId = setTimeout(() => {
      removeAlert(newAlertObj.timerId);
      newAlertObj.callback();
    }, ms);

    console.log("NEW " + newAlertObj.timerId);

    /*setAlerts((prev) => {
      console.log("--> PREV: " + prev);
      return [...prev, newAlertObj];
    });*/

    alerts.current.push(newAlertObj);

    return newAlertObj;
  };

  const removeAlert = (timerId) => {
    clearTimeout(timerId);
    console.log("KILL " + timerId);
    //setAlerts((prev) => prev.filter((alert) => alert.timerId !== timerId));

    alerts.current = alerts.current.filter(
      (alert) => alert.timerId !== timerId
    );
  };

  const clearTimers = () => {
    alerts.current.forEach((alert) => {
      console.log("CLEAR " + alert.timerId);
      clearTimeout(alert.timerId);
    });
    alerts.current.length = 0;
  };

  return {
    alerts,
    addAlert,
    clearTimers,
    removeAlert,
  };
};

//https://stackoverflow.com/questions/77221997/when-a-react-component-gets-unmounted-does-the-custom-hook-triggers-its-useeffe

/*export const useBanner = () => {    
    const [alerts, setAlerts] = useState([]);

    const addAlert = (message: string) => {
        const newAlertObj = {
            id: `success-${performance.now()}`,
            message,
            timerId: undefined,
        };

        newAlertObj.timerId = setTimeout(() => {
            removeAlert(newAlertObj.id);
        }, ALERT_DELAY_MILLISECONDS);

        setAlerts((prev) => [...prev, newAlertObj]);
    };

    const removeAlert = (id: string) => {
        setAlerts((prev) => prev.filter((alert) => alert.id !== id));
    };

    const clearTimers = () => {
        alerts.forEach((alert) => clearTimeout(alert.timerId));
    };

    return {
        alerts,
        addAlert,
        clearTimers,
        removeAlert,
    };
};*/
